<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="800" scrollable>
    <v-card>
      <v-card-title class="grey darken-3 white--text">
        <v-icon left dark>mdi-map-marker-multiple</v-icon>
        Visitantes del Blog
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <div ref="blogMap" style="height: 450px; width: 100%;"></div>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <span class="caption grey--text">Ubicaciones de las visitas al blog</span>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import forumService from '@/services/forumService.js';

// Corregir rutas de íconos de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'BlogMapDialog',
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      mapa: null,
      ubicaciones: []
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initMapa();
            this.cargarUbicaciones();
          }, 200);
        });
      } else {
        if (this.mapa) {
          this.mapa.remove();
          this.mapa = null;
        }
      }
    }
  },
  methods: {
    initMapa() {
      if (this.mapa) {
        this.mapa.remove();
      }
      if (!this.$refs.blogMap) return;

      this.mapa = L.map(this.$refs.blogMap, {
        zoomControl: true,
        dragging: true,
        scrollWheelZoom: true,
        doubleClickZoom: true,
      });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
      }).addTo(this.mapa);

      // Vista inicial centrada
      this.mapa.setView([0, 0], 2);
    },
    cargarUbicaciones() {
      forumService.getBlogVisitMap().then(res => {
        this.ubicaciones = res.data.ubicaciones || [];
        this.marcarUbicaciones();
      }).catch(() => {});
    },
    marcarUbicaciones() {
      if (!this.mapa) return;
      const bounds = [];

      this.ubicaciones.forEach(ubicacion => {
        const lat = parseFloat(ubicacion.latitude);
        const lng = parseFloat(ubicacion.longitude);

        if (!isNaN(lat) && !isNaN(lng)) {
          const latLng = [lat, lng];
          bounds.push(latLng);
          L.marker(latLng)
            .bindPopup('<b>' + (ubicacion.ciudad || '') + '</b><br>' + (ubicacion.pais || ''))
            .addTo(this.mapa);
        }
      });

      if (bounds.length > 0) {
        this.mapa.fitBounds(bounds, {
          padding: [50, 50],
          maxZoom: 5
        });
      }
    }
  }
};
</script>
